import Vue from 'vue';
import HeaderComp from '../vue/Header/index.vue';

export default function(el) {
  if (el === null) return false;
  const v = new Vue({
    el,
    components: {
      'header-comp': HeaderComp,
    },
  });

  return v;
}
